module.exports = __webpack_public_path__ + "static/Akebia_MOD_Animation_02_Pathogenesis_of_Anemia_due_to_CKD-d2df300f1aba7d5054bb7b42ea85bb9d.mp4";